export default "__VITE_ASSET__BZYYy_5j__"